<template>
  <el-card class="page-container">
    <el-row>
      <h1 style="font-size: 24px; font-weight: bold">头像管理</h1>
    </el-row>
    <el-row class="search" :gutter="10">
      <el-col :span="3">
        <el-select v-model="queryInfo.status" placeholder="状态">
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="queryInfo.round" placeholder="轮次">
          <el-option
            v-for="item in round"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-button type="primary" @click="query">查询</el-button>
      <el-button type="primary" @click="dialogVisible = true">头像使用</el-button>

      <el-tooltip
        class="item"
        effect="dark"
        content="选中后头像后操作，可批量"
        placement="top-start"
      >
        <el-button
          type="primary"
          @click="review(null, 1)"
          :disabled="idList.length === 0"
        >
          <i class="el-icon-check" />
          通过
        </el-button>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="选中后头像后操作，可批量"
        placement="top-start"
      >
        <el-button type="danger" @click="review(null, 2)" :disabled="idList.length === 0">
          <i class="el-icon-close" />
          不通过
        </el-button>
      </el-tooltip>
    </el-row>
    <el-row>
      <!-- <div class="avatar_container"> -->
      <el-checkbox-group v-model="idList" class="avatar_container">
        <el-checkbox
          v-for="(item, idx) in datalist"
          :key="idx"
          :label="item.id"
          :disabled="item.status !== 0"
          class="avatar_box"
        >
          <img @click.stop :src="item.head" :preview-src-list="[item.head]" />
          <div class="btns">
            <!-- <el-button
              v-if="item.status === 0"
              type="primary"
              round
              size="mini"
              @click="review(item.id, 1)"
            >
              <i class="el-icon-check" />
            </el-button>
            <el-button
              v-if="item.status === 0"
              type="danger"
              size="mini"
              round
              @click="review(item.id, 2)"
            >
              <i class="el-icon-close" />
            </el-button> -->

            <el-button size="mini" disabled>
              {{ status.find((status) => status.value === item.status).label }}
            </el-button>
          </div>
        </el-checkbox>
      </el-checkbox-group>
      <!-- </div> -->
    </el-row>
    <el-pagination
      :current-page.sync="pageInfo.page"
      layout="total, prev, pager, next"
      background
      @current-change="handleCurrentChange"
      :total="pageInfo.total"
      class="pagination"
      :page-size="pageInfo.pageSize"
    />
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-select v-model="setRound" placeholder="第几轮">
        <el-option
          v-for="item in round"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRound">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getCountryMore, getLanguage } from "@/utils/normalApi.js";
import { datainfor } from "@/utils/formdata.js";
export default {
  name: "robot_avatar",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      status: [
        { label: "未审核", value: 0 },
        { label: "审核成功", value: 1 },
        { label: "审核失败", value: 2 },
        { label: "使用中", value: 3 },
      ],
      queryInfo: {
        // 0未审核 默认选中 1审核成功 2审核失败 3使用中
        status: 0,
        // 轮次 从/head/round_config接口获取
        round: 1,
      },
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 100,
      },
      round: [],
      setRound: "",
      datalist: [],
      idList: [],
    };
  },
  created() {
    this._getRound();
    this.query();
  },
  methods: {
    async query() {
      this.loading = true;
      const params = {
        page: this.pageInfo.page,
        ...this.queryInfo,
      };
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.robot_avatar_query +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        withCredentials: true,
        params,
      });
      this.loading = false;
      if (res.code != 0) return this.$message.error(res.msg);
      this.datalist = res.data.data;
      this.pageInfo.total = res.data.total;
      this.$message.success("查询成功");
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.query();
    },
    async review(id, status) {
      this.$confirm("确认提交？")
        .then(async () => {
          this.loading = true;
          if (id != null) {
            this.idList = [id];
          }
          const data = {
            status,
            idList: this.idList,
          };
          const { data: res } = await this.$axios({
            method: "post",
            url:
              this.$store.getters.path.robot_avatar_status +
              "?username=" +
              this.$store.getters.username +
              "&token=" +
              this.$store.getters.token,
            withCredentials: true,
            data,
          });
          if (res.code != 0) return this.$message.error(res.msg);
          this.loading = false;
          this.$message.success("操作成功");
          this.query();
          done();
        })
        .catch(() => {});
    },
    async submitRound() {
      this.loading = true;
      const params = {
        round: this.setRound,
      };
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.robot_avatar_set_round +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        withCredentials: true,
        params,
      });
      if (res.code != 0) return this.$message.error(res.msg);
      this.$message.success("设置成功");
      this.dialogVisible = false;
      this.setRound = "";
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.setRound = "";
          done();
        })
        .catch(() => {});
    },
    async _getRound() {
      const { data: res } = await this.$axios({
        method: "get",
        url:
          this.$store.getters.path.robot_avatar_round +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        withCredentials: true,
      });
      if (res.code != 0) return this.$message.error(res.msg);
      res.data.forEach((item) => {
        this.round.push({
          label: `第${item}轮`,
          value: item,
        });
      });
      this.queryInfo.round = this.round[0].value;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 80vh;
  .avatar_container {
    width: 100%;
    max-height: 70vh;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    .avatar_box {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-radius: 12px;
      padding: 8px;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        object-fit: cover;
      }
      .btns {
        button {
          width: 92%;
        }
      }
    }
  }
}
</style>
